import { Injectable } from '@angular/core';
import { IPlanName } from 'src/app/models/IPlanName';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlanNameService {

  constructor(private http: HttpClient) { }

  // Get all plan name details
  getAllPlanNames(): Observable<IPlanName[]> {
    return this.http.get<IPlanName[]>(`${configuration.apiUrl + 'Master/PlanNames'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  //Add plan name details
  addPlanNameDetails(planNameDetails: IPlanName): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/PlanNames'}`, planNameDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

   // Update plan name details 
   updatePlanNameDetails(planNameDetails: IPlanName): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/PlanNames'}`, planNameDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
